import { AppThunk } from '../../../store/rootReducer';
import { getRawSignal } from '../../ecg/clients/ecg.client';
import * as rawSignalActions from '../actions/raw-signal.actions';

export const loadRawSignal =
  (ecgId: string): AppThunk =>
  async (dispatch, getState) => {
    const rawSignal = await getRawSignal(ecgId);

    if (rawSignal != null) {
      dispatch(rawSignalActions.load({ rawSignal }));
    }
  };
